import { render } from "./lesson-activity.vue?vue&type=template&id=2021ace6&ts=true"
import script from "./lesson-activity.ts?vue&type=script&lang=ts&external"
export * from "./lesson-activity.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__